import { DTX_APP_ID, DTX_PUBLISHER_ID } from '@moment/layouts/Ads/constants.ts';
import { BannerAdSizes } from '@moment/components/GalleryAd/ad-constants.ts';

export const loadAllAdScripts = async (scripts: (string | undefined)[]) => {
  const scriptList = scripts
    .filter((it) => !!it)
    .map((item) => {
      return new Promise((resolve, reject) => {
        const scriptEl = document.createElement('script');
        if (item) {
          scriptEl.src = item;
        }
        scriptEl.onload = resolve;
        scriptEl.onerror = reject;

        document.body.appendChild(scriptEl);
      });
    });
  return Promise.all(scriptList);
};

export const loadAdScripts = async () => {
  const list = ['/assets/scripts/dtx-web-sdk.umd.cjs'];
  return loadAllAdScripts(list);
};

interface EventPayload {
  eventName: string;
  callback: (data: any) => void; // Adjust 'any' to a specific type if known
}

export const initializeAds = (
  listeners: EventPayload[],
  appBundle?: string,
  appName?: string,
  appVersion?: string,
  advId?: string,
  userId?: string
) => {
  let hostingAppDetails = undefined;
  if (appBundle && appName && appVersion) {
    hostingAppDetails = {
      packageName: appBundle,
      appVersion: appVersion,
      appName: appName,
    };
  }

  try {
    window.DTXWeb.getInstance().initialize({
      appId: DTX_APP_ID,
      hostingAppDetails: hostingAppDetails,
      advertiserId: advId,
      advertiserIdType: 'android',
      publisherId: DTX_PUBLISHER_ID,
      siteId: window?.location?.hostname,
      userId: userId,
    });
    listeners.forEach((l) => {
      window.DTXWeb.getInstance().addEventListener(l.eventName, l.callback);
    });
  } catch (e) {
    console.log(`Error initializing SDK`, e);
  }
};

export interface AdRequest {
  bannerConfig: BannerAdSizes;
  deviceLanguage: string;
  iabCategories?: string[];
  testData?: object;
}

export interface LoadAdRequest {
  success: boolean;
  error?: Error;
}

export const renderAd = async (
  containerId: string,
  tagId: string,
  bannerSizes: BannerAdSizes[],
  lang: string,
  iabCategories?: string[],
  testData?: any
): Promise<boolean> => {
  let ad: undefined;
  try {
    const bannerAd = window.DTXWeb.getInstance().banner(tagId);
    const adRequest: AdRequest = {
      bannerSizes: bannerSizes.map((b) => b.toDtxSizing()),
      deviceLanguage: lang,
      iabCategories: iabCategories,
    };
    if (testData) {
      adRequest.testData = {
        test_data: testData,
      };
    }
    const result: LoadAdRequest = await bannerAd.request(adRequest);
    if (result.success) {
      ad = bannerAd;
      console.log(`Ad ${containerId} loaded`);
      ad.render(containerId);
    } else {
      console.error(`Error loading ad`, result.error);
    }
    return result.success;
  } catch (e) {
    console.log(`Error rendering ad`, e);
  }
  return !!ad;
};
